import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { TabMenuModule } from 'primeng/tabmenu';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { SidebarModule } from 'primeng/sidebar';
import { TimelineModule } from 'primeng/timeline';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RatingModule } from 'primeng/rating';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TagModule } from 'primeng/tag';
import { TreeTableModule } from 'primeng/treetable';
import { FileUploadModule } from 'primeng/fileupload';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { GalleriaModule } from 'primeng/galleria';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { DragDropModule } from 'primeng/dragdrop';
import { ChipModule } from 'primeng/chip';
import { SkeletonModule } from 'primeng/skeleton';
import { StepsModule } from 'primeng/steps';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MenuModule,
    PaginatorModule,
    TabMenuModule,
    TooltipModule,
    CalendarModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    AutoCompleteModule,
    InputTextareaModule,
    RippleModule,
    ConfirmDialogModule,
    DividerModule,
    SidebarModule,
    TimelineModule,
    RadioButtonModule,
    OverlayPanelModule,
    RatingModule,
    CheckboxModule,
    InputSwitchModule,
    TagModule,
    TreeTableModule,
    FileUploadModule,
    SelectButtonModule,
    TieredMenuModule,
    GalleriaModule,
    TableModule,
    AccordionModule,
    TabViewModule,
    DragDropModule,
    SkeletonModule,
    ChipModule,
  ],
  exports: [
    MenuModule,
    PaginatorModule,
    TabMenuModule,
    TooltipModule,
    CalendarModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    AutoCompleteModule,
    InputTextareaModule,
    RippleModule,
    ConfirmDialogModule,
    DividerModule,
    SidebarModule,
    TimelineModule,
    RadioButtonModule,
    OverlayPanelModule,
    RatingModule,
    CheckboxModule,
    InputSwitchModule,
    TagModule,
    TreeTableModule,
    FileUploadModule,
    SelectButtonModule,
    TieredMenuModule,
    GalleriaModule,
    TableModule,
    AccordionModule,
    TabViewModule,
    DragDropModule,
    SkeletonModule,
    ChipModule,
    StepsModule
  ]
})
export class PrimengModule { }
